/* Clear+ — landings advertorial. Compte à rebours (minuit, comme la SOURCE), barres collantes,
   chronologie qui se remplit au défilement (SOURCE hommes : .tl-fill + .tl-item.on). */
(function () {
  'use strict';

  function deuxChiffres(n) { return String(n).padStart(2, '0'); }

  function tic() {
    var maintenant = new Date();
    var fin = new Date(maintenant);
    fin.setHours(23, 59, 59, 999);
    var s = Math.max(0, Math.floor((fin - maintenant) / 1000));
    var h = deuxChiffres(Math.floor(s / 3600));
    var m = deuxChiffres(Math.floor(s / 60) % 60);
    var sec = deuxChiffres(s % 60);
    document.querySelectorAll('[data-ngadv-cd]').forEach(function (el) {
      var a = el.querySelector('[data-cd-h]');
      var b = el.querySelector('[data-cd-m]');
      var c = el.querySelector('[data-cd-s]');
      if (a) a.textContent = h;
      if (b) b.textContent = m;
      if (c) c.textContent = sec;
    });
  }

  /* Barre collante : visible après le haut de page, masquée quand une offre est à l'écran. */
  function barresCollantes() {
    var barres = document.querySelectorAll('[data-ngadv-sticky]');
    if (!barres.length) return;
    var hero = document.querySelector('[data-ngadv-hero]');
    var offres = Array.prototype.slice.call(document.querySelectorAll('[data-ngadv-offer]'));
    function maj() {
      var seuil = hero ? hero.getBoundingClientRect().bottom : 400;
      var vh = window.innerHeight;
      var surOffre = offres.some(function (o) {
        var r = o.getBoundingClientRect();
        return r.top < vh * 0.85 && r.bottom > vh * 0.15;
      });
      var on = seuil < 0 && !surOffre;
      barres.forEach(function (b) {
        b.classList.toggle(b.getAttribute('data-ngadv-sticky') || 'on', on);
      });
    }
    window.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj, { passive: true });
    maj();
  }

  function chronologie() {
    var tls = document.querySelectorAll('[data-ngadv-tl]');
    if (!tls.length) return;
    function maj() {
      var milieu = window.innerHeight * 0.6;
      tls.forEach(function (tl) {
        var fill = tl.querySelector('[data-tl-fill]');
        var r = tl.getBoundingClientRect();
        var max = Math.max(0, r.height - 24);
        var h = Math.min(max, Math.max(0, milieu - r.top - 12));
        if (fill) fill.style.height = h + 'px';
        tl.querySelectorAll('[data-tl-item]').forEach(function (it) {
          it.classList.toggle('on', it.getBoundingClientRect().top + 32 < milieu);
        });
      });
    }
    window.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj, { passive: true });
    maj();
  }

  function demarrer() {
    tic();
    setInterval(tic, 1000);
    barresCollantes();
    chronologie();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
